import { inject, observer } from 'mobx-react'
import * as React from 'react'
import { Jaw } from '../../../shared/Constants'
import { Utils } from '../../../shared/Utils'
import { CalculatorStoreInstance } from '../../../stores/CalculatorStore'
import { Routes } from '../../Routes'

interface IProps {
  store?: CalculatorStoreInstance
  jaw: Jaw
}

@inject('store')
@observer
export class BoneGraftingView extends React.Component<IProps> {
  // -------------------------------------------------------------------------- LIFECYCLE

  componentDidMount () {
    const { store, jaw } = this.props
    const requirement = store!.offer.getJawRequirement(jaw)
    const jawRoute = Routes.getJawRoute(jaw)
    if (!requirement) {
      return store!.redirectToRoute(jawRoute)
    }
  }

  // -------------------------------------------------------------------------- RENDERING

  render(): React.ReactNode {
    const { jaw } = this.props
    const jawRoutes = Routes.getJawRoute(jaw)
    const routes = jawRoutes.subRoutes.boneGrafting.subRoutes

    return (<div>
      {Utils.renderRoutes(routes)}
    </div>)
  }
}
